import React from "react";
import { useT } from "../i18n/LanguageContext";
import { SectionTag } from "../components/Section";
import { PDF } from "../i18n/photos";
import {
  Fingerprint, Users, Vote, FileText, Server, ShieldCheck, Database, Layers,
} from "lucide-react";

const SERVICES = [
  { icon: Fingerprint, k: "cap.civil", img: PDF.identityPortrait },
  { icon: Users, k: "cap.census", img: PDF.peopleCollage },
  { icon: Vote, k: "cap.elections", img: PDF.flagsCollage },
  { icon: FileText, k: "cap.ecm", img: PDF.serverRoomCams },
  { icon: Server, k: "cap.ict", img: PDF.dataCenterEmpty },
  { icon: ShieldCheck, k: "cap.security", img: PDF.networkCable },
  { icon: Database, k: "cap.erp", img: PDF.peopleDesks },
  { icon: Layers, k: "cap.simp", img: PDF.meeting },
];

export default function ServicesPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-services">
      <section className="relative overflow-hidden border-b border-white/10 py-16 md:py-24">
        <img src={PDF.dataCenterEmpty} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-bg/80 via-brand-bg/95 to-brand-bg" />
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("services.tag")}</SectionTag>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("services.title")}
          </h1>
          <p className="mt-6 max-w-2xl text-base text-brand-textDim">{t("services.sub")}</p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <div className="grid gap-px border border-white/10 bg-white/5 md:grid-cols-2">
            {SERVICES.map(({ icon: Icon, k, img }, i) => (
              <article key={k} className="group relative flex flex-col gap-6 overflow-hidden bg-brand-bg p-8 transition-colors hover:bg-[#0E0E0E] md:p-10">
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-20"
                  style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center" }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-bg/40 to-brand-bg pointer-events-none" />
                <div className="relative flex items-center justify-between">
                  <span className="font-mono text-[10px] tracking-[0.25em] text-brand-textDim">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Icon className="h-6 w-6 text-white/70 transition-colors group-hover:text-brand-red" strokeWidth={1.4} />
                </div>
                <h3 className="relative font-heading text-2xl tracking-tight text-white">{t(`${k}.title`)}</h3>
                <p className="relative text-base leading-relaxed text-brand-textDim">{t(`${k}.desc`)}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
